import type { DocumentCreateModel } from 'shared/domain/document/documentCreateModel';
import { documentClient } from 'shared/domain/document/documentClient';
import { Services } from 'shared/domain/messages/message';
import { useUploadProgressStore } from 'store/uploadProgress';

async function saveDocument(
  baseUrl: string,
  document: DocumentCreateModel,
  uniqueId: string
): Promise<number> {
  try {
    return await documentClient.create(baseUrl, document, uniqueId);
  } catch (error) {
    useUploadProgressStore.getState().markUploadPlaceholderFailed(uniqueId);
    throw error;
  }
}

/**
 * Saves documents locally and resolves with their local ids, in order; the
 * worker uploads them next, and the upload progress follows each file.
 */
export function saveDocuments(
  baseUrl: string,
  documents: DocumentCreateModel[]
): Promise<number[]> {
  const uniqueIds = useUploadProgressStore.getState().addPendingUploadPlaceholders(
    documents.map((document) => ({ title: document.title, type: Services.DOCUMENTS }))
  );
  return Promise.all(
    documents.map((document, index) => saveDocument(baseUrl, document, uniqueIds[index]))
  );
}
